import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PIXEL_ID = '660289207469688';

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

// Track custom Facebook Pixel events
export const trackFBEvent = (eventName: string, params?: Record<string, any>) => {
  if (window.fbq) {
    window.fbq('track', eventName, params);
  }
};

// Track custom (non-standard) events
export const trackFBCustomEvent = (eventName: string, params?: Record<string, any>) => {
  if (window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
};

const FacebookPixel = () => {
  const location = useLocation();

  useEffect(() => {
    // Load Facebook Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);

    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);

    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);

  // Track Lead event on contact/partner pages
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/contact-us') || path.includes('/become-partner')) {
      trackFBEvent('Lead', { content_name: path });
    }
    if (path.includes('/sustainwize/download-material')) {
      trackFBEvent('ViewContent', { content_name: 'Download Material' });
    }
  }, [location]);

  return null;
};

export default FacebookPixel;
